import React, { FC, useRef, useEffect } from 'react';

interface ImageProps {
  src: string;
  alt: string;
  isLazyLoad?: boolean;
  className?: string;
  onLoad?: () => void;
  onLoadStart?: () => void;
}

export const Image: FC<ImageProps> = ({
  src,
  alt,
  isLazyLoad,
  onLoad,
  onLoadStart,
  className,
}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (imageRef.current && !imageRef.current.complete && onLoadStart) {
      onLoadStart();
    }
  }, [onLoadStart, src]);

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => onLoad && onLoad()}
      ref={imageRef}
      loading={isLazyLoad ? 'lazy' : 'eager'}
      className={className}
    />
  );
};
